import React from 'react';
import * as Styles from './GenericStep.styles';
import { Button } from 'gatorcomponents';
import { GenericStepProps } from './GenericStep.types';
import { useResize } from '@/hooks/useResize';

const GenericStep = ({
  icon,
  title,
  testId = 'generic-step',
  subtitle,
  description,
  imageSrc,
  children,
  buttonsProps,
  contentWidthFlexible,
  centerContent = true,
}) => {
  const rightButtonAsArray = buttonsProps && buttonsProps.rightButton && Array.isArray(buttonsProps.rightButton);

  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width <= 600;

  return (
    <Styles.Wrapper data-testid={testId}>
      <Styles.Container>
        <Styles.Content $contentWidthFlexible={contentWidthFlexible} $centerContent={centerContent}>
          {icon && icon}
          {title && (
          <Styles.Title $centerContent={centerContent} dangerouslySetInnerHTML={{ __html: title }} />
          )}
          {subtitle && <Styles.Subtitle>{subtitle}</Styles.Subtitle>}
          {description && <Styles.Description>{description}</Styles.Description>}
          {children}
        </Styles.Content>
        {imageSrc && (<Styles.Image src={imageSrc} />)}
      </Styles.Container>
      {buttonsProps && (
      <Styles.ButtonsWrapper $middleButton={buttonsProps.middleButton}>
        {buttonsProps.middleButton && (
        <Styles.ButtonContainer>
          <Button
            {...buttonsProps.middleButton}
            size="large"
            width={mobile && 'full'}
          />
        </Styles.ButtonContainer>
        )}
        {!buttonsProps.middleButton && (
        <>
          <Styles.ButtonContainer>
            {buttonsProps.leftButton && (
            <Button
              {...buttonsProps.leftButton}
              variant="secondary"
              size="large"
              width={mobile && 'full'}
            />
            )}
          </Styles.ButtonContainer>

          <Styles.ButtonContainer>
            {buttonsProps.rightButton && !rightButtonAsArray && (
            <Button
              {...buttonsProps.rightButton}
              onClick={buttonsProps.rightButton.onClick}
              size="large"
              width={mobile && 'full'}
              testId={buttonsProps.rightButton.testId}
            />
            )}

            {buttonsProps.rightButton && rightButtonAsArray && (
              buttonsProps.rightButton.map(button => (
                <React.Fragment key={`${button.testId}-${button.label}`}>
                  <Button
                    {...button}
                    onClick={button.onClick}
                    size="large"
                    width={mobile && 'full'}
                    testId={button.testId}
                  />
                </React.Fragment>
              ))
            )}
          </Styles.ButtonContainer>
        </>
        )}
      </Styles.ButtonsWrapper>
      )}
    </Styles.Wrapper>
  );
};
GenericStep.propTypes = GenericStepProps;

export default GenericStep;
